import template from './land-drainage.jade';
import items from '../../../enums/land-communications-location';
import itemsDrainageType from '../../../enums/drainage-type';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.aboutObjectLandDrainage', [])
    .directive('cianAfAboutObjectLandDrainage', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.items = items;
            this.itemsDrainageType = itemsDrainageType;
            this.ad.drainage = this.ad.drainage || {};

            const isOnTypes = ['border', 'location'];
            this.isOn = () => isOnTypes.includes(this.ad.drainage.locationType);

            this.isOnPossibleConnect = () => this.ad.drainage.locationType === 'no';

            this.maxCapacity = 1000;
            this.minCapacity = 0;

            this.validationCapacity = validation(this.form, 'drainage.capacity', {
                parse: 'Введите число',
                max: 'Допустимо не более 3 символов',
                min: 'Введите число',
            });
        },
        controllerAs: 'landDrainage',
        template,
    }))
    .name;
